/* global $ */
import { PageTransitions } from '.';

class Sasaki {
  constructor(modules) {
    this.modules = modules;
    this.observables = [];

    this.initializedModulesArr = [];

    this.init();
  }

  init() {
    this.initializeModules();

    this.observables.push(new PageTransitions());

    $.each(this.observables, (i, observable) => {
      observable.addListener('modules:init', this.initializeModules.bind(this));
      observable.addListener('modules:deinit', this.deinitializeModules.bind(this));
    });
  }

  initializeModules() {
    $.each(this.modules, (i, mod) => {
      this.initializedModulesArr.push(new mod());
    });
  }

  deinitializeModules() {
    this.initializedModulesArr.map(initializedMod => initializedMod.deinit());

    this.initializedModulesArr = [];
  }
}

export default Sasaki;
